import { ElementRef, inject, NgZone } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export abstract class AbstractCloseOnClickOut {
  isOpen = false;
  private readonly onDestroy = new Subject();
  protected readonly ngZone: NgZone = inject(NgZone);
  protected readonly elementRef: ElementRef = inject(ElementRef);

  open() {
    this.isOpen = true;
    this.ngZone.runOutsideAngular(() => {
      fromEvent(document, 'click')
        .pipe(takeUntil(this.onDestroy))
        .subscribe(({ target }) => {
          this.ngZone.run(() => {
            if (!this.elementRef.nativeElement.contains(target as HTMLElement) && this.isOpen && !this.hasFocus()) this.close();
          });
        });
    });
  }

  close(): any {
    this.isOpen = false;
    this.onDestroy.next(undefined);
  }

  destroy() {
    this.onDestroy.complete();
  }


  hasFocus(){
    return false
  }
}
